import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { dispatchItemToRedux } from "Redux/Actions/CommonActions";
import ReducerTypes from "Redux/Types/ReducerTypes";

const EachChooseList = ({ id, name, setTitleSelectSub, catBox }) => {
  const { subId } = useParams();

  const [activeID, setActiveID] = useState(id);
  const dispatch = useDispatch();

  useEffect(async () => {
    await setActiveID(subId);
    // eslint-disable-next-line
  }, [subId]);

  const handleScroll = (ref) => {
    window.scrollTo({
      behavior: "smooth",
      top: ref.current.offsetTop,
    });
  };
  return (
    <Link
      to={`/sub_category/${id}`}
      onClick={(e) => {
        handleScroll(catBox);
        setTitleSelectSub(e.currentTarget.text);
        setActiveID(id);

        dispatch(
          dispatchItemToRedux({
            type: ReducerTypes.PARAMS,
            payload: {
              id,
              page: 1,
              section: "sub_category",
            },
          })
        );
      }}
      className={`link-sub-category w-100 d-block py-3 border-bottom px-2 ${
        activeID === id ? "bg-dap-success text-light" : null
      }`}
    >
      {name}
    </Link>
  );
};

export default EachChooseList;
